import React from 'react';
import MainBody from '../templates/MainBody';
import { cybintContent } from '../data';

//technical, ips, mac addresses, ssl, data breaches, attack surface mapping,
//showdan, whois, shodan, censys, spyse, binaryedge

const CYBINT: React.FC = () => {
  return <MainBody data={cybintContent} />;
};

export default CYBINT;